<template>
  <div class="productInfo">
    <v-data-table
      :items="kpiData"
      :headers="isOrder ? headers : headersForSale"
      :items-per-page="-1"
      hide-default-footer
      class="rounded-lg elevation-1 width100 mb-5"
    >
      <!-- ヘッダの上に行を追加します。 -->
      <template v-slot:header="props">
        <thead>
          <tr>
            <th colspan="3" style="text-align: center"></th>
            <th colspan="2" style="text-align: center">1月</th>
            <th colspan="2" style="text-align: center">2月</th>
            <th colspan="2" style="text-align: center">3月</th>
            <th colspan="2" style="text-align: center">4月</th>
            <th colspan="2" style="text-align: center">5月</th>
            <th colspan="2" style="text-align: center">6月</th>
            <th colspan="2" style="text-align: center">7月</th>
            <th colspan="2" style="text-align: center">8月</th>
            <th colspan="2" style="text-align: center">9月</th>
            <th colspan="2" style="text-align: center">10月</th>
            <th colspan="2" style="text-align: center">11月</th>
            <th colspan="2" style="text-align: center">12月</th>
            <th colspan="2" style="text-align: center">合計</th>
          </tr>
        </thead>
      </template>
      <template v-slot:item.isSelected="{ item }">
        <v-checkbox
          v-model="selectedIds"
          :value="item.productId"
          @click="isChecked"
        ></v-checkbox>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    isOrder: {
      type: Boolean
    },
    aggregateTableData: {
      type: Array
    }
  },
  data() {
    return {
      // 発注用の表示データ
      headers: [
        { text: '', value: 'isSelected' },
        { text: '仕入先名', value: 'supplierName', width: 25 },
        { text: '商品名', value: 'productName', width: 25 },
        { text: '発注数', value: 'amount1' },
        { text: '仕入価格', value: 'price1' },
        { text: '発注数', value: 'amount2' },
        { text: '仕入価格', value: 'price2' },
        { text: '発注数', value: 'amount3' },
        { text: '仕入価格', value: 'price3' },
        { text: '発注数', value: 'amount4' },
        { text: '仕入価格', value: 'price4' },
        { text: '発注数', value: 'amount5' },
        { text: '仕入価格', value: 'price5' },
        { text: '発注数', value: 'amount6' },
        { text: '仕入価格', value: 'price6' },
        { text: '発注数', value: 'amount7' },
        { text: '仕入価格', value: 'price7' },
        { text: '発注数', value: 'amount8' },
        { text: '仕入価格', value: 'price8' },
        { text: '発注数', value: 'amount9' },
        { text: '仕入価格', value: 'price9' },
        { text: '発注数', value: 'amount10' },
        { text: '仕入価格', value: 'price10' },
        { text: '発注数', value: 'amount11' },
        { text: '仕入価格', value: 'price11' },
        { text: '発注数', value: 'amount12' },
        { text: '仕入価格', value: 'price12' },
        { text: '発注合計', value: 'amountTotal' },
        { text: '仕入価格合計', value: 'priceTotal' }
      ],
      // 注文用の表示データ
      headersForSale: [
        { text: '', value: 'isSelected' },
        { text: '仕入先名', value: 'supplierName', width: 25 },
        { text: '商品名', value: 'productName', width: 25 },
        { text: '販売数', value: 'amount1forSale' },
        { text: '販売価格', value: 'price1forSale' },
        { text: '販売数', value: 'amount2forSale' },
        { text: '販売価格', value: 'price2forSale' },
        { text: '販売数', value: 'amount3forSale' },
        { text: '販売価格', value: 'price3forSale' },
        { text: '販売数', value: 'amount4forSale' },
        { text: '販売価格', value: 'price4forSale' },
        { text: '販売数', value: 'amount5forSale' },
        { text: '販売価格', value: 'price5forSale' },
        { text: '販売数', value: 'amount6forSale' },
        { text: '販売価格', value: 'price6forSale' },
        { text: '販売数', value: 'amount7forSale' },
        { text: '販売価格', value: 'price7forSale' },
        { text: '販売数', value: 'amount8forSale' },
        { text: '販売価格', value: 'price8forSale' },
        { text: '販売数', value: 'amount9forSale' },
        { text: '販売価格', value: 'price9forSale' },
        { text: '販売数', value: 'amount10forSale' },
        { text: '販売価格', value: 'price10forSale' },
        { text: '販売数', value: 'amount11forSale' },
        { text: '販売価格', value: 'price11forSale' },
        { text: '販売数', value: 'amount12forSale' },
        { text: '販売価格', value: 'price12forSale' },
        { text: '販売数合計', value: 'amountTotalforSale' },
        { text: '販売価格合計', value: 'priceTotalforSale' }
      ],
      kpiData: [],
      selectedIds: []
    }
  },
  async created() {
    this.selectedIds = this.aggregateTableData.map((item) => item['productId'])
    this.kpiData = this.aggregateTableData
    this.$emit('table-check-event', this.selectedIds)
  },
  methods: {
    isChecked() {
      this.$emit('table-check-event', this.selectedIds)
    }
  }
}
</script>
<style scoped lang="scss">
.productInfo {
  font-size: 6px;
}
</style>
